var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0997 6.99991C8.0997 6.29004 8.20725 5.25332 8.30475 4.45941C8.37923 3.85289 8.9874 3.46673 9.54868 3.70834C10.9031 4.29136 12.1591 5.19291 12.9984 6.55334C13.1673 6.82717 13.1673 7.17267 12.9984 7.44651C12.1592 8.80697 10.9032 9.7085 9.54875 10.2915C8.98749 10.5331 8.37933 10.147 8.30483 9.54047C8.2073 8.74655 8.0997 7.70981 8.0997 6.99991Z",
    fill: "#84C70D",
    fillOpacity: 0.43
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0997 6.99991C8.0997 6.29004 8.20725 5.25332 8.30475 4.45941C8.37923 3.85289 8.9874 3.46673 9.54868 3.70834C10.9031 4.29136 12.1591 5.19291 12.9984 6.55334C13.1673 6.82717 13.1673 7.17267 12.9984 7.44651C12.1592 8.80697 10.9032 9.7085 9.54875 10.2915C8.98749 10.5331 8.37933 10.147 8.30483 9.54047C8.2073 8.74655 8.0997 7.70981 8.0997 6.99991Z",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09961 7H3.6027",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewArrowRight);
export default __webpack_public_path__ + "static/media/overview-arrow-right.a50cfe41a8d32c4273b3a075355b8509.svg";
export { ForwardRef as ReactComponent };